import { render, staticRenderFns } from "./dataSelect.vue?vue&type=template&id=f04321d0&scoped=true&"
import script from "./dataSelect.vue?vue&type=script&lang=ts&"
export * from "./dataSelect.vue?vue&type=script&lang=ts&"
import style0 from "./dataSelect.vue?vue&type=style&index=0&id=f04321d0&prod&lang=less&scoped=true&"
import style1 from "./dataSelect.vue?vue&type=style&index=1&id=f04321d0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04321d0",
  null
  
)

export default component.exports